import { Box, Container, SystemStyleObject } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

import { pxToRem } from '../../../theme';

export function DrawerBottomButtonsContainer({
  children,
  stylesContainer,
}: PropsWithChildren & { stylesContainer?: SystemStyleObject }) {
  return (
    <Box
      display={['block', 'none']}
      position="absolute"
      px={3}
      left={0}
      right={0}
      bottom={0}
      bg="background"
      zIndex="modal"
      {...stylesContainer}
      borderTop="thin"
    >
      <Container py={5} px={0} maxWidth={pxToRem(480)}>
        {children}
      </Container>
    </Box>
  );
}
